import { isString } from "@payair/e-com-common-sdk/core/Validators";
import { validateApplePayContactField } from "./ApplePayContactField";
import { validateApplePayLineItem } from "./ApplePayLineItem";
import { validateApplePayMerchantCapability } from "./ApplePayMerchantCapability";
import { validateApplePayPaymentContact } from "./ApplePayPaymentContact";
import { validateApplePayShippingContactEditingMode, } from "./ApplePayShippingContactEditingMode";
import { validateApplePayShippingMethod } from "./ApplePayShippingMethod";
import { validateApplePayShippingType } from "./ApplePayShippingType";
/** @internal */
export var validatePaymentRequest = function (applePayPaymentRequest) {
    var errorMessage = [];
    if (!applePayPaymentRequest) {
        errorMessage.push("applePayInitParams.applePayPaymentRequest not defined");
        return errorMessage;
    }
    // merchantCapabilities validation
    var merchantCapabilitiesValidationResult = validateArrayField("merchantCapabilities", applePayPaymentRequest.merchantCapabilities, validateApplePayMerchantCapability);
    errorMessage = errorMessage.concat(merchantCapabilitiesValidationResult);
    // supportedNetworks validation
    var supportedNetworks = applePayPaymentRequest.supportedNetworks;
    if (!supportedNetworks)
        errorMessage.push("supportedNetworks not defined");
    else if (!Array.isArray(supportedNetworks))
        errorMessage.push("supportedNetworks is not an array");
    else {
        supportedNetworks.forEach(function (supportedNetwork) {
            if (!isString(supportedNetwork))
                errorMessage.push("supportedNetworks is not a string");
        });
    }
    // total validation
    if (applePayPaymentRequest.total)
        errorMessage = errorMessage.concat(validateApplePayLineItem(applePayPaymentRequest.total));
    // lineItems validation
    if (applePayPaymentRequest.lineItems) {
        var lineItems = applePayPaymentRequest.lineItems;
        if (!Array.isArray(lineItems))
            errorMessage.push("".concat(lineItems, " is not an array"));
        else {
            lineItems.forEach(function (lineItem) {
                var validationResult = validateApplePayLineItem(lineItem);
                errorMessage = errorMessage.concat(validationResult);
            });
        }
    }
    // requiredBillingContactFields validation
    if (applePayPaymentRequest.requiredBillingContactFields) {
        var validationResult = validateArrayField("requiredBillingContactFields", applePayPaymentRequest.requiredBillingContactFields, validateApplePayContactField);
        errorMessage = errorMessage.concat(validationResult);
    }
    // requiredShippingContactFields validation
    if (applePayPaymentRequest.requiredShippingContactFields) {
        var validationResult = validateArrayField("requiredShippingContactFields", applePayPaymentRequest.requiredShippingContactFields, validateApplePayContactField);
        errorMessage = errorMessage.concat(validationResult);
    }
    // billingContact validation
    if (applePayPaymentRequest.billingContact) {
        var validationResult = validateApplePayPaymentContact(applePayPaymentRequest.billingContact);
        errorMessage = errorMessage.concat(validationResult);
    }
    // shippingContact validation
    if (applePayPaymentRequest.shippingContact) {
        var validationResult = validateApplePayPaymentContact(applePayPaymentRequest.shippingContact);
        errorMessage = errorMessage.concat(validationResult);
    }
    // shippingMethods validation
    var shippingMethods = applePayPaymentRequest.shippingMethods;
    if (shippingMethods !== undefined) {
        if (!Array.isArray(shippingMethods))
            errorMessage.push("shippingMethods is not an array");
        else {
            shippingMethods.forEach(function (object) {
                errorMessage = errorMessage.concat(validateApplePayShippingMethod(object));
            });
        }
    }
    // shippingType validation
    if (applePayPaymentRequest.shippingType) {
        var validationResult = validateApplePayShippingType(applePayPaymentRequest.shippingType);
        if (!validationResult)
            errorMessage = errorMessage.concat("shippingType is not valid");
    }
    // shippingContactEditingMode validation
    if (applePayPaymentRequest.shippingContactEditingMode) {
        var validationResult = validateApplePayShippingContactEditingMode(applePayPaymentRequest.shippingContactEditingMode);
        if (!validationResult)
            errorMessage = errorMessage.concat("shippingContactEditingMode is not valid");
    }
    // TODO when coupon code feature will be added
    // // supportsCouponCode validation
    // if(applePayPaymentRequest.supportsCouponCode) {
    //   if(!isBoolean(applePayPaymentRequest.supportsCouponCode)) errorMessage.push("supportsCouponCode is not valid")
    // }
    // // couponCode validation
    // if(applePayPaymentRequest.couponCode) {
    //   if(!isString(applePayPaymentRequest.couponCode)) errorMessage.push("couponCode is not valid")
    // }
    // supportedCountries validation
    var supportedCountries = applePayPaymentRequest.supportedCountries;
    if (supportedCountries !== undefined) {
        if (!Array.isArray(supportedCountries))
            errorMessage.push("supportedCountries is not an array");
        else {
            supportedCountries.forEach(function (object) {
                if (!isString(object))
                    errorMessage.push("".concat(object, " in supportedCountries is not a string"));
            });
        }
    }
    // applicationData validation
    if (applePayPaymentRequest.applicationData) {
        if (!isString(applePayPaymentRequest.applicationData))
            errorMessage.push("applicationData is not valid");
    }
    return errorMessage;
};
var validateArrayField = function (arrayName, array, validator) {
    var errorMessage = [];
    if (!Array.isArray(array))
        errorMessage.push("".concat(arrayName, " is not an array"));
    else {
        array.forEach(function (object) {
            !validator(object) && errorMessage.push("\"".concat(object, "\" value in ").concat(arrayName, " array is not valid"));
        });
    }
    return errorMessage;
};
